import React, { PropsWithChildren } from 'react';

// Utilities
import bem from '../../../lib/bemUtils/bem';

export enum FlagModifier {
  LIGHT = 'light',
  MARGIN = 'margin',
}

type FlagProps = PropsWithChildren<{ modifier?: FlagModifier.MARGIN | FlagModifier.LIGHT }>;

export function Flag({ children, modifier }: FlagProps) {
  return <strong className={bem('flag', modifier)}>{children}</strong>;
}
